import { createFileRoute } from '@tanstack/react-router';
import { BroadcastFormSubmissionsRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastFormSubmissionsRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastFormSubmissionsRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/form-submissions',
)({
  component: BroadcastFormSubmissionsRoute,
});
